// ** Core JWT Import
import useJwt from '@src/@core/auth/jwt/useJwt'

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

const { jwt } = useJwt(
    {
        loginEndpoint: `${API_BASE_URL}/api/account/login`,
        // registerEndpoint: "/jwt/register",
        refreshEndpoint: `${API_BASE_URL}/Security/UserSession/Renewal`,
        logoutEndpoint: `${API_BASE_URL}/Security/UserSession/Logout`
    }

)

export default jwt
